
const adw = window.adw;
/**
 * Add an event listener to the JS trigger for getting popular posts from Parsely.
 *
 * @example
 *
 * <div id="recent-posts" class="js-tabs">
 *     <div class="posts">
 *         //some code, maybe a wordpress loop
 *     </div>
 * <div class="col-12 align-center js-replace-with-posts js-load-more-btn"><a href="javascript:void(0)" class="btn">Read More</a></div
 *
 * <?php $Queried_WP_Term_Obj = get_queried_object(); ?>
 *
 * <script>
 *   // Configuration for recent posts
 *   const startingIndexRecent       =       1;
 *   const recentPostsTrigger        =       '#recent-posts .js-load-more-btn a';
 *   const replaceWithRecentPosts    =       '#recent-posts .js-replace-with-posts';
 *   // Initialize everything.
 *   adw.parsely.initializeRecentPostsTrigger( recentPostsTrigger, replaceWithRecentPosts, '<?= $Queried_WP_Term_Obj->taxonomy ?>', '<?= $Queried_WP_Term_Obj->slug ?>', startingIndexRecent );
 *
 * </script>
 *
 * @param {string}  popularPostsTrigger   Query string for triggering the loading and markup of posts.
 * @param {string}  replaceWithPosts      Query string for node that new posts will replace.
 * @param {string}  taxonomy              Name of the taxonomy
 * @param {string}  taxonomyTerm          Taxonomy term.
 * @param {int}     index                 Pagination index.
 */
export default function initializeRecentPostsTrigger( popularPostsTrigger, replaceWithPosts, taxonomy, taxonomyTerm, index ) {
    const trigger = document.querySelector( popularPostsTrigger );
    trigger.addEventListener( 'click', function( e ) {

        e.preventDefault();
        console.log( 'FROM PARCEL BUILD' );                                                         // stops page jumps.
        adw.parsely.getTaxPostsByTermID( taxonomy, taxonomyTerm, index )
            .then( response => {
                return renderPosts( replaceWithPosts, response );                   // return is to execute the next .then after renderPosts();
            })
            .then( () => {
                initializeRecentPostsTrigger( popularPostsTrigger, replaceWithPosts, taxonomy, taxonomyTerm, ++index );           // Reinitialize the trigger on new content.
            })
            .catch( error => {

                    console.log('Error in getting Parsley Data', error);            // if error log it

                    trigger.parentNode.removeChild(trigger);                        // delete the Read More button
                }
            );

    } );
}

/**
 *
 * @param replaceWithPosts  Node that new posts will replace.
 * @param data              Post data.
 */
async function renderPosts( replaceWithPosts, data ) {
    const markup = await getPostMarkup( data );

    const postMarkupWithMoreButton = await markup +
        '<div class="col-12 align-center js-replace-with-posts js-load-more-btn"><a href="javascript:void(0)" class="btn">Read More</a></div>';

    data ? $( replaceWithPosts ).replaceWith( postMarkupWithMoreButton )
        : $( replaceWithPosts ).replaceWith( markup );
}

async function getPostMarkup( data ) {
    return data.reduce( async function( markup, dataItem ) {
        return ( await markup + await buildPost( dataItem.ID ) );
    }, Promise.resolve('') );
}

/**
 * todo: setup some try/catch blocks. Also there should be an endpoint for processing an array and returning the markup rather then pinging the api for each post ID.
 * @param id
 * @returns {string}
 */
async function buildPost( id ) {
    const response  = await fetch(`${window.location.origin}/wp-json/adw-contributor/v1/contributor-markup/${id}`);
    const data = await response.json();
    return data.markup;
}
